import React from "react";
import UseGetDashBoardData from "../../../../../Components/Hooks/useDashboardData";
import NuDate from "../../../../../Components/Utils/NuDate";

const Insurance = () => {
  const { data, loading } = UseGetDashBoardData(`/new-dashboard/maintenance-details`);

  return (
    <div className="bg-white p-5 rounded-2xl border border-gray-100 shadow-[0_4px_25px_rgba(0,0,0,0.04)] transition-all duration-300">
      <div className="flex justify-between items-center pb-3 border-b border-gray-100 mb-3">
        <div className="flex items-center space-x-2">
          <div className="w-7 h-7 rounded-lg bg-blue-50 flex items-center justify-center text-blue-600">
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
            </svg>
          </div>
          <h3 className="text-sm font-semibold text-gray-800">Insurance Renewal Watch</h3>
        </div>

        <span className="text-xs font-bold px-2.5 py-0.5 rounded-full bg-blue-50 text-blue-700 border border-blue-200/50">
          Policy Alerts
        </span>
      </div>

      {loading ? (
        <div className="h-48 flex items-center justify-center animate-pulse">
          <div className="h-32 bg-gray-100 rounded-xl w-full"></div>
        </div>
      ) : (
        <div className="max-h-56 overflow-y-auto pr-1">
          <table className="w-full text-xs">
            <thead className="sticky top-0 bg-gray-50 text-gray-500 font-semibold border-b border-gray-200">
              <tr>
                <th className="py-2 px-2 text-left">Vehicle</th>
                <th className="py-2 px-2 text-left">Assignee</th>
                <th className="py-2 px-1 text-center">Next Renewal</th>
                <th className="py-2 px-2 text-right">Days Left</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {data && data.length > 0 ? (
                data.map((item, index) => {
                  const daysLeft = parseInt(item?.days || 0);
                  const isUrgent = daysLeft <= 15;
                  const isWarning = daysLeft > 15 && daysLeft <= 30;

                  return (
                    <tr key={index} className="hover:bg-gray-50/70 transition-colors">
                      <td className="py-2.5 px-2 font-semibold text-gray-900 truncate max-w-[110px]">
                        {item?.name || "N/A"}
                      </td>
                      <td className="py-2.5 px-2 text-gray-600 truncate max-w-[110px]">
                        {item?.assignedTo || "Unassigned"}
                      </td>
                      <td className="py-2.5 px-1 text-center text-gray-600">
                        {item?.nextRenewal ? <NuDate value={item?.nextRenewal} format="DD-MMM-YYYY" /> : "N/A"}
                      </td>
                      <td className="py-2.5 px-2 text-right">
                        <span
                          className={`text-[10px] font-bold px-2.5 py-0.5 rounded-full border ${
                            isUrgent
                              ? "bg-rose-50 text-rose-700 border-rose-200/50"
                              : isWarning
                              ? "bg-amber-50 text-amber-700 border-amber-200/50"
                              : "bg-emerald-50 text-emerald-700 border-emerald-200/50"
                          }`}
                        >
                          {item?.days || 0} days
                        </span>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={4} className="py-6 text-center text-gray-400">
                    No insurance records available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Insurance;